export const TNC_CONTENT_MD = `### **INTRODUCTION**
Hi there! We would like to extend the warmest of welcomes to ‘you’, a prospective subscriber of AEM Algorithm’s ‘Journaler’ software. AEM Algorithm aims to bridge the gap between cryptocurrency and financial services in a market where there are currently no ‘easy-to-use’ cryptocurrency accounting tools.
<br>
Before we provide you with the tools to immerse yourself in our innovative world, we want to ensure that you’re fully aware of your rights and obligations as a ‘Journaler’ subscriber. Read through our ‘Terms and Conditions’, referring to each subheading for specific clarification, and tick ‘yes’ once you have fully understood and agree with the terms outlined.
<br>
If you have any further questions or concerns, please feel free to contact our friendly team through any of the various channels outlined below.
<br>
Thank you for your interest and we look forward to facilitating your cryptocurrency journey!

### **OVERVIEW**
This website is operated by AEM Algorithm. Throughout the site, the terms “we”, “us” and “our” refer to AEM Algorithm. AEM Algorithm offers this website, including all information, tools and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.
<br>
<br>

**1\\. Acceptance of terms**

*   \\- These T&C (‘Term and Conditions’) are a legally binding contract between ‘you’ and us. As part of these T&C, you agree to comply with the most recent version of this document, which is incorporated by reference into these T&C. If you access or use the Services, or continue accessing or using the Services after being notified of a change to the T&C, you confirm that you have read, understand and agree to be bound by the T&C.
<br>
<br>

**2\\. Reference to privacy policy**

2.1 Privacy Policy;
*   \\- AEM Algorithm ("us", "we", or "our") operates [https://www.aemalgorithm.io/](https://www.aemalgorithm.io/) (the "Site")
*   \\- This section informs you of our policies regarding the collection, use and disclosure of personal Information we receive from users of the Site. We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.

2.2 Information collection and use
*   \\- While using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name ("Personal Information").
*   \\- By subscribing to Journaler you agree to receive product updates, notifications and offers, however you are able to unsubscribe at any time.

2.3 Log Data
*   \\- Like many site operators, we collect information that your browser sends whenever you visit our Site ("Log Data"). This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages and other statistics.

2.4 Communications
*   \\- We may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information that may help us to inform/update you about.

2.5 Cookies
*   \\- Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive. Like many sites, we use "cookies" to collect information.

2.6 Security
*   \\- The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.

2.7 Transaction and Exchange Rate Data
*   By inputting a tax rate or using the tax calculator, you acknowledge that you are responsible for verifying its accuracy and applying a tax rate applicable to your business. Any imported or exported tax calculations are performed at your discretion.
*   AEM Algorithm’s _Journaler_ is designed to provide flexibility and customization across its features. It is recommended that all transaction information used in financial and tax reporting is verified by a qualified accountant or other authorised expert before use.
*   Exchange rates and related data are provided for convenience only. AEM Algorithm does not control these sources and makes no guarantees regarding the accuracy, completeness, or timeliness of this information. You should independently verify all exchange rate data before relying on it for financial or tax purposes.
*   Data sources: CryptoCompare (primary source), CoinMarketCap (secondary source), and CoinGecko.
<br>
<br>

**3\\. Subscription payments and billing**

3.1 Prices

We offer subscription plans on a **monthly, yearly, or enterprise basis**, depending on transaction volumes and the number of wallets you manage. Our standard plans include:
*   Compact
*   Starter
*   Premium
*   Pro
*   Enterprise: Custom pricing based on requested features and usage
Yearly subscription packages receive an overall **10% discount** compared with 12 months of monthly fees.

3.2 Plans and Billing
*   Blockchain Integrations: Direct wallet connections are subject to limits based on your plan:
    *   Compact: 100 transactions/month
    *   Starter: 500 transactions/month
    *   Premium: 5,000 transactions/month
    *   Pro: 10,000 transactions/month
    *   Enterprise: Custom limits based on requirements
*   Imported Transactions (manually via file import): No limits.
*   Upgrades: When upgrading your plan, a ne**w billing cycle starts**, and transaction access continues as usual under the new plan.

3.3 Seasonal promotions:
*   Promotional prices for subscription services of ‘Journaler’ will be strictly limited to the designated timeline outlined in the relevant advertisement. Prices will only be offered during the relevant seasonal cycle. Once this period has expired, the offer will cease and no longer be available for purchase.
<br>
<br>

**4\\. Termination of account**

4.1 You may terminate your subscription at any time. Termination will take effect **at the end of the current billing cycle**, and no further charges will apply after that cycle.

4.2 User opted for cancellation of services:
Monthly subscription fees
*   Cancellation within the first 7 days to receive a full refund - only applies only to those accounts that have not performed any exports.
*   The user will have access to all features of the respective subscription service until the conclusion of the month. After such a date, the contract between the provider and the user will expire and expectation of payment will cease.
Yearly subscription services:
*   The user will have access to all features of the respective subscription service until the conclusion of the month. After such a date, the contract between the provider and the user will expire and expectation of payment will cease. If cancelled within the first month of subscription, ‘AEM Algorithm’ will refund the user the amount equivalent to the remaining 11 months of the year.
*   Cancellation after the cooling off period has ended means that you will lose any of your unused credits or limits before the end of the billing period.

4.3 Chargeback
*   If, at any time, we record a decline, chargeback or other rejection of a charge of any due and payable Subscription Fees on Customer’s Account, this will be considered as a breach of Customer’s payment obligations hereunder, and Customer’s use of the Service may bedisabled or terminated and such use of the Service will not resume until Customer re-subscribes for any such Service, and pay any applicable Subscription Fees in full, including any fees and expenses incurred by us and/or any Third Party Service for each.
*   Chargeback received (including handling and processing charges and fees incurred by the payment processor), without derogating from any other remedy that may be applicable to us under these Terms or applicable law.
<br>
<br>

**5\\. SOFTWARE LICENCE (END USER LICENCE AGREEMENT – EULA)**

5.1 Licence Grant

Subject to your compliance with these Terms and payment of applicable fees, AEM Algorithm grants you a limited, non-exclusive, non-transferable, non-sublicensable, revocable licence to access and use Journaler solely for your internal business or personal cryptocurrency accounting purposes.

This licence does not transfer ownership of the software.

5.2 Permitted Use

You may use Journaler only:
* For lawful purposes
* In accordance with these Terms
* For your own internal accounting, reporting, and financial management

5.3 Licence Restrictions

You must NOT:
* Copy, modify, or create derivative works of the software
* Reverse engineer, decompile, or attempt to extract source code
* Sell, resell, sublicense, lease, or commercially exploit the software
* Provide access to unauthorised third parties
* Use the software to violate any law or regulation
* Circumvent usage limits, security, or subscription controls
* Use automated bots, scraping, or data mining without permission

5.4 Suspension or Revocation

We may suspend or terminate your licence immediately if you breach these Terms, misuse the software, fail to pay fees, or attempt to compromise system integrity.

5.5 Updates and Changes

Journaler may automatically update, improve, modify, or remove features. Continued use after updates constitutes acceptance of changes.

5.6 Third-Party Components

Journaler may include integrations, APIs, or services provided by third parties. Your use of those services may be subject to separate third-party terms.

<br>

**6\\. Intellectual property rights and copyright**

6.1 Recognition of intellectual property ownership
\\- The user, you, acknowledges that all content included in and/or made available through the ‘Journaler’ software, such as text, graphics, logos, button icons, images, audio clips, digital downloads, data complications and software patents are the property of AEM Algorithm and are protected by Australian and international copyright laws.

6.2 Condition breaches of IP and copyright
\\- You acknowledge that you cannot interfere with the proprietary interest of AEM Algorithm. Failure to comply with any of these provisions will lead to the termination and/or suspension of your account, disabling the use of any subscribed services. AEM Algorithm will not be liable for issuing a refund on the basis of this termination.
<br>
<br>

**7\\. Indemnities and limitation of liability**

7.1 Application of consumer law
AEM Algorithm’s _Journaler_ product is a cryptocurrency accounting middleware application intended for use by both businesses (B2B) and consumers (C2B). To the extent permitted by law, you agree that consumer protection laws generally do not apply to your use of the Services.
Where consumer protection laws do apply and cannot be lawfully excluded (for example, the Competition and Consumer Act 2010 (Cth) in Australia), nothing in these Terms limits or excludes any statutory warranties, guarantees, rights, or remedies available to you.
In such cases, AEM Algorithm’s liability is limited, at its discretion, to:
*   the replacement, repair, or resupply of the Services; or
*   a pro-rata refund of any pre-paid fees for the unused portion of your annual subscription.
<br>
<br>

**8.Anti-Money Laundering (AML) Disclaimer**
*   To support compliance and enhance risk assessment, we integrate AMLBot, a third-party solution provided by SAFELEMENT LIMITED, to perform Anti-Money Laundering (AML) checks on digital assets. By using our services, you acknowledge and agree to the following:

8.1 Use of Third-Party Service
*   AML checks are conducted through AMLBot. We do not own, operate, or control AMLBot’s technology, infrastructure, or assessment criteria. AMLBot is solely responsible for the development, maintenance, and performance of its tools and systems.

8.2 Warranties or guarantee on AML Results
*   While AMLBot strives to deliver accurate and up-to-date information, we do not warrant or guarantee the accuracy, completeness, reliability, or timeliness of any AML reports or results provided.

8.3 User Responsibility
*   Any decisions or actions you take based on AML check results are made at your own discretion and risk. We are not liable for any losses, damages, or legal consequences that may arise from the use or non-use of AMLBot results.

8.4 No Endorsement
*   The use of AMLBot does not imply any endorsement or assurance from us regarding the legitimacy, risk level, or compliance of any digital asset, wallet address, or transaction.

8.5 Terms and Updates
*   AMLBot operates under its own [User Agreement](https://amlbot.com/files/AMLBot_SERVICE_AGREEMENT.pdf?_gl=1*1vhz6es*_up*MQ..*_gs*MQ..&gclid=CjwKCAjwiezABhBZEiwAEbTPGKiYeuWERvWpU2mL2BYAvaji_sTFqvbMa6xw1lfdazHOG9gcGxArSBoC9toQAvD_BwE&gbraid=0AAAAA-iEGGaoZx9W-BLduKetXHHTpEuvQ) and [Privacy Policy](https://amlbot.com/privacy-policy?_gl=1*1vhz6es*_up*MQ..*_gs*MQ..&gclid=CjwKCAjwiezABhBZEiwAEbTPGKiYeuWERvWpU2mL2BYAvaji_sTFqvbMa6xw1lfdazHOG9gcGxArSBoC9toQAvD_BwE&gbraid=0AAAAA-iEGGaoZx9W-BLduKetXHHTpEuvQ), which may change independently of our platform. By continuing to use our AML screening feature, you accept and are bound by AMLBot’s current terms and conditions.
<br>
<br>

**9\\. Changes to the Terms and Conditions**

9.1 Changes to terms
\\- This ‘Terms and conditions’ is effective since 30/05/2021 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page. We reserve the right to update or change our T&C at any time and you should check these T&C periodically. Your continued use of the Service after we post any modifications to the T&C on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified T&C. If we make any material changes to this T&C, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.

9.2 Contact Us
\\- If you have any questions about these ‘Terms and Conditions’, please contact us.
\\- EMAIL : [support@aemalgorithm.io](mailto:support@aemalgorithm.io)
\\- POST: PO BOX 37, Elwood, Victoria 3184, Australia

9.3 Last Updated: 15/09/2025`
